import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=2d2dabbf"
import script from "./LogoutIcon.vue?vue&type=script&lang=ts"
export * from "./LogoutIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports